type ApiResponse<T> = {
    data: T | null;
    error: string | null;
};

const DEFAULT_ERROR = "Something went wrong. Please try again.";

const handleRequest = async <T>(fn: () => Promise<any>): Promise<ApiResponse<T>> => {
    try {
        const res = await fn();

        console.log("API Response:", res);

        if (!res) {
            return { data: null, error: "Empty response from server" };
        }

        // ✅ Handle API-level error
        if (res?.error) {
            return {
                data: null,
                error: res.error.message || DEFAULT_ERROR,
            };
        }

        return {
            data: res.data ?? null,
            error: null,
        };

    } catch (err: any) {
        console.error("API Error:", err);

        const message =
            err?.response?._data?.message ||
            err?.data?.message ||
            err?.message ||
            DEFAULT_ERROR;

        return {
            data: null,
            error: message,
        };
    }
};


// address.service.ts
export const AddressService = {
    async addUserAddress(payload: any) {
        return handleRequest<any>(() =>
            useAPIHandler("post", "/account/addresses", {
                body: payload,
                auth: true,
            })
        );
    },

    async deleteUserAddress(addressId: string) {
        return handleRequest<any>(() =>
            useAPIHandler("delete", `/account/addresses/${addressId}`, {
                auth: true,
            })
        );
    },

    async getUserAddress() {
        return handleRequest<any>(() =>
            useAPIHandler("get", `/account/addresses`, {
                auth: true,
            })
        );
    },
};